import { render } from "./LogradouroEditPage.vue?vue&type=template&id=bc596078"
import script from "./LogradouroEditPage.vue?vue&type=script&lang=js"
export * from "./LogradouroEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__